import {
  FormEmojiTextInput,
  SwitchInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";

import { TTicketServiceAreaForm } from "../TicketServiceAreaSchema";
import { TicketChannelOutsideBusinessDayField } from "./TicketChannelOutsideBusinessDayField";
import { TicketChannelStepOutsideBusinessDayField } from "./TicketChannelStepOutsideBusinessDayField";
interface OutsideBusinessDayFieldProps {
  isAllTheTime?: boolean;
}

const translationPath = "chatBot.page.service.ticketServiceArea.";

const OutsideBusinessDayField = ({
  isAllTheTime,
}: OutsideBusinessDayFieldProps) => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TTicketServiceAreaForm>();

  useEffect(() => {
    if (isAllTheTime) {
      setValue("showOutsideBusinessDay", false);
    }
  }, [isAllTheTime, setValue]);

  const showOutsideBusinessDay = useWatch({
    name: "showOutsideBusinessDay",
    control,
    defaultValue: true,
  });

  return (
    <>
      <Grid item xs={12}>
        <SwitchInput
          name="showOutsideBusinessDay"
          label={t(translationPath + "show_outside_business_day")}
          disabled={isAllTheTime}
        />
      </Grid>

      {showOutsideBusinessDay && (
        <>
          <TicketChannelOutsideBusinessDayField />
          <TicketChannelStepOutsideBusinessDayField />

          <Grid item xs={12}>
            <FormEmojiTextInput
              name="summaryOutsideBusinessDay"
              label={t(translationPath + "summary_outside_business_day")}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={12}>
            <FormEmojiTextInput
              name="messageOutsideBusinessDay"
              label={t(translationPath + "message_outside_business_day")}
              fullWidth
              size="small"
              multiline
              rows={4}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(OutsideBusinessDayField);
